import { FETCH } from '../../../actions/fetch';

export default responses => () => next => (action) => {
  if (action.type !== FETCH) {
    return next(action);
  }

  if (!(action.payload.url in responses)) {
    throw new Error(`No responses defined for ${action.payload.url}`);
  }

  next(action);

  const res = responses[action.payload.url];

  if (res.ok === false) {
    throw res;
  }

  return Promise.resolve(res);
};
